import { button } from '../../../../../component/component'

import { toSmtp } from '../../../../../lib/timecode'

export default function(o,c){

  var lastTime = null

  var update = function(){
    if(o.video){
      div.show()
      var time = o.video.currentTime
      if(time != lastTime){      
        var smtp = toSmtp(time)
        div.html(smtp)
        lastTime = time
      }
    }
    requestAnimationFrame(update)
  }

  requestAnimationFrame(update)


  var div =
    button('00:00:00:00',null,true)

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/admin/controls/buttons/pos/pos.js